import deepmerge from 'deepmerge';
import { ASSIGNMENT_LINK_STATUS } from 'lib/constants';
import { getTimestamp } from 'lib/DatetimeManager';
import { getBucketData } from 'lib/utilityFunctions';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initialState = {
  currentAssignmentId: '',
};

const assignmentModeReducer = (state = initialState, { type, payload, stateData = {} }) => {
  switch (type) {
    case 'INIT_ASSIGNMENT_MODE': {
      const { assignmentId, gameId, type: linkType, levels } = payload;
      if (assignmentId) {
        // no saved data in gamestate - new assignment
        if (!state[assignmentId]) {
          return {
            ...state,
            currentAssignmentId: assignmentId,
            [assignmentId]: {
              gameId,
              type: linkType,
              levels,
              levelsMastered: [],
              failures: {},
              status: ASSIGNMENT_LINK_STATUS.ASSIGNED,
            },
          };
        }

        // saved data exists in gamestate
        // resume assignment and update currentAssignmentId based on url
        return {
          ...state,
          currentAssignmentId: assignmentId,
        };
      }

      return state;
    }
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL: {
      const savedData = getBucketData(stateData.ASSIGNMENT_PROGRESS);
      return Object.keys(savedData).length ? savedData : state;
    }

    case 'START_ASSIGNMENT':
      return deepmerge(state, {
        [state.currentAssignmentId]: {
          status: ASSIGNMENT_LINK_STATUS.IN_PROGRESS,
          startDate: getTimestamp(),
        },
      });

    case 'SHOW_ASSIGNMENT_NAV':
      return deepmerge(state, { [state.currentAssignmentId]: { showNav: payload } });

    case 'UPDATE_ASSIGNMENT_PROGRESS': {
      const { currentAssignmentId } = state;
      const { isSuccess, gameId, level } = payload;
      const levelIndex = level - 1; // progress screen and level tracking are 0 based
      const levelsMastered = [...state[currentAssignmentId].levelsMastered, levelIndex];
      let failures = { ...state[currentAssignmentId].failures };

      const status = levelsMastered.length === state[currentAssignmentId].levels.length
        ? ASSIGNMENT_LINK_STATUS.COMPLETE
        : ASSIGNMENT_LINK_STATUS.IN_PROGRESS;

      if (!isSuccess) {
        const key = `${gameId}_${levelIndex}`;
        failures = {
          ...state[currentAssignmentId].failures,
          [key]: (state[currentAssignmentId].failures[key] || 0) + 1,
        };
      }
      return {
        ...state,
        [currentAssignmentId]: {
          ...state[currentAssignmentId],
          levelsMastered,
          failures,
          status,
          ...(status === ASSIGNMENT_LINK_STATUS.COMPLETE && { endDate: getTimestamp() }),
        },
      };
    }

    default:
      return state;
  }
};

export default assignmentModeReducer;
